import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

import { ZfStack, ZfTextButton } from '@zafire/react';
import { setAccountCaseInformation } from 'reducers/caseReducer';
import { t } from 'i18next';

export interface MenuUIProps {
  menu: any[];
}
interface MenuItem {
  action: () => void;
  translationKey: string;
  pathname: string;
  id?: string;
  onClick?: () => void;
}

const WeNaTopbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems: MenuItem[] = [
    {
      action: () => navigate('/home'),
      translationKey: 'topbar.home.title',
      pathname: '/home/tasks/my-tasks',
      id: 'home-link',
    },
    {
      action: () => navigate('/partners'),
      translationKey: 'topbar.partners.title',
      pathname: '/partners',
      id: 'partners-link',
    },
    {
      action: () => {
        dispatch(
          setAccountCaseInformation({
            accountNumber: '',
            accountName: '',
            brUid: '',
          }),
        );
        navigate('/business-relation/edit');
      },
      translationKey: 'topbar.businessRelations.title',
      pathname: '/business-relation/edit',
      id: 'businessRelations-link',
    },
    {
      action: () => navigate('/document-center'),
      translationKey: 'topbar.documentCenter.title',
      pathname: '/document-center/document-overview',
      id: 'document-center-link',
    },
    {
      action: () => navigate('/gphd'),
      translationKey: 'topbar.gphd.title',
      pathname: '/gphd',
      id: 'gphd-link',
    },
  ];

  return (
    <div
      style={{
        padding: 'var(--padding-vertical-sm) var(--padding-horizontal-xl)',
        borderBottom: 'var(--border-weight-px) solid var(--border-color-default-emphasis)',
      }}
    >
      <ZfStack direction="row">
        {menuItems.map((item) => (
          <ZfTextButton
            selected={location.pathname.startsWith(item.pathname)}
            key={item.id}
            size="small"
            hierarchy="tertiary"
            onClick={item.action}
          >
            {t(item.translationKey)}
          </ZfTextButton>
        ))}
      </ZfStack>
    </div>
  );
};

export default WeNaTopbar;
